const displayName = 'Buddy'
const appName     = 'buddy'

export { displayName, appName }
